"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentNameManager = void 0;
class EnvironmentNameManager {
    envNameRegex = /^[\w\d-_]+$/;
    envConfigNameRegex = /^config\.(?<envName>[\w\d-_]+)\.json$/i;
    envStateNameRegex = /^state\.(?<envName>[\w\d-_]+)\.json$/i;
    schema = "https://aka.ms/teamsfx-env-config-schema";
    defaultEnvName = "dev";
    localEnvName = "local";
    testToolEnvName = "testtool";
    playgroundEnvName = "playground";
    sandboxEnvName = "sandbox";
    getDefaultEnvName() {
        return this.defaultEnvName;
    }
    getLocalEnvName() {
        return this.localEnvName;
    }
    getTestToolEnvName() {
        return this.testToolEnvName;
    }
    getPlaygroundEnvName() {
        return this.playgroundEnvName;
    }
    getSandboxEnvName() {
        return this.sandboxEnvName;
    }
    getNonRemoteEnvNames() {
        return [this.localEnvName, this.testToolEnvName, this.playgroundEnvName];
    }
    isRemoteEnvironment(env) {
        return this.getNonRemoteEnvNames().indexOf(env) === -1;
    }
}
exports.environmentNameManager = new EnvironmentNameManager();
//# sourceMappingURL=environmentName.js.map